var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-box"},[_c('video',{staticClass:"mzd-video",attrs:{"preload":"auto","controls":"","controlsList":"nodownload"}},[_c('source',{attrs:{"src":_vm.page.url}}),_vm._v("Your browser does not support the video tag. ")]),_vm._v(" "),_c('i',{staticClass:"far fa-volume-up text-very-muted audio-icon"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b2a53a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/AudioMedia.vue
// module id = null
// module chunks = 